/*
 * @Author: Hong.Zhang
 * @Date: 2025-01-02 14:47:45
 * @Description:
 */
import dayjs, { Dayjs } from 'dayjs';

export const isAgeWithinRange = (date: Dayjs, range: number[]) => {
  const [min, max] = range;
  if (min === undefined || max === undefined) {
    throw new Error('Invalid range format');
  }
  const today = dayjs();

  return (
    today.isAfter(date.add(min, 'year')) &&
    today.isBefore(date.add(max, 'year'))
  );
};
